class EnquiryData {

	/**
	 * Are we using the legacy enquiry form?
	 */
	public isLegacy: boolean;

	/**
	 *
	 * Dynamic form data
	 */
	public data: any;

	/*
	 * Get enquiry based context menu params
	 * We are creating a condition for each enquiry form on the system
	 * if the current collection is smart, then we only need to check if the collection is enabled for enquiry
	 * otherwise, if we are in a legacy world, we just need to check if the enquiry is enabled
	 * refer to CollectionPanel.ts -> getEnquiryMenuGroup where these conditions are first used
	 * @param params - the current context menu params
	 * @returns {{}}
	 */
	public static getMenuData(params:any): any {
		if (EnquiryData.data && !iwCore.isEmptyObject(EnquiryData.data)) {
			let parsedModel;
			for (let zoneId in this.data) {
				if (EnquiryData.data.hasOwnProperty(zoneId)) {
					parsedModel = JSON.parse(EnquiryData.data[zoneId]);
					// condition based on if it is a smart collection or not
					params['canenquire_'+zoneId] = params.smartid ? !parsedModel['collectionsEnabled'] : !!iw.enquireEnabled;
				}
			}
		} else if (EnquiryData.isLegacy) {
			// if it is a legacy form, then no dynamic conditions
			params.canenquire = !!iw.enquireEnabled
		}

		return params;
	}
}